import {
  advisorUpdated, advisorsListUpdated, userUpdated, setAnalyticsProps, setCurrentPaymentOption, setForceLogout, orderDetailsUpdated
} from '../actions/shared_actions';
import { log, LOG_LEVELS } from '../../common/config/app_logger';
import { parseAndTrackAnalyticEvents } from '../actions/analytics';
import { toCamelCase } from '../../common/config/utils';
import { updateCurrencyAction, updateFxRate } from '../actions/application';

export const refreshReducersFromResponse = (res, { ignoreUserUpdate = false } = {}) => {
  const {
    user, advisor, advisors, analyticProps, currentPaymentOption, order, analyticEvents
  } = res;
  if (!ignoreUserUpdate && user) {
    window.store.dispatch(userUpdated(user));
    if (user?.currency) {
      window.store.dispatch(updateCurrencyAction(user?.currency));
    }
    if (user?.fxRate) {
      window.store.dispatch(updateFxRate(user?.fxRate));
    }
  }
  if (order) {
    window.store.dispatch(orderDetailsUpdated(order));
  }
  if (advisor) {
    window.store.dispatch(advisorUpdated(advisor));
    if (advisor?.currency) {
      window.store.dispatch(updateCurrencyAction(advisor?.currency));
    }
    if (advisor?.fxRate) {
      window.store.dispatch(updateFxRate(advisor?.fxRate));
    }
  }
  if (advisors) {
    window.store.dispatch(advisorsListUpdated(advisors));
  }
  if (analyticProps) {
    window.store.dispatch(setAnalyticsProps(analyticProps));
  }
  if (currentPaymentOption) {
    window.store.dispatch(setCurrentPaymentOption(currentPaymentOption));
  }
  if (analyticEvents) {
    parseAndTrackAnalyticEvents(analyticEvents);
  }
};

export const trackAnalyticEventsFromError = (error) => {
  error.json()
    .then((jsonError) => {
      const jsonErrorCamelCase = toCamelCase(jsonError);

      if (jsonErrorCamelCase.analyticEvents) {
        parseAndTrackAnalyticEvents(jsonErrorCamelCase.analyticEvents);
      }
    });
};

export const handle401UnauthorizedError = (response) => {
  if (response.status === 401 && window.currentUserId) {
    log(LOG_LEVELS.INFO, 'API', 'Received 401 error for logged in user, setting force logout flag');
    window.store.dispatch(setForceLogout(true));
    return true;
  }
  return false;
};
